import { render, staticRenderFns } from "./ExamSchedulesStudentWarning.vue?vue&type=template&id=720c9e5e"
import script from "./ExamSchedulesStudentWarning.vue?vue&type=script&lang=js"
export * from "./ExamSchedulesStudentWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports